import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { initLenis, scrollTop } from "@/lib/scroll";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Individuals from "@/pages/Individuals";
import Employers from "@/pages/Employers";
import About from "@/pages/About";
import Education from "@/pages/Education";
import ArticlePage from "@/pages/ArticlePage";
import FaqPage from "@/pages/FaqPage";
import Contact from "@/pages/Contact";
import BenefitsDecoded from "@/pages/BenefitsDecoded";
import Unsubscribe from "@/pages/Unsubscribe";
import NotFound from "@/pages/NotFound";
import PlanCheck from "@/pages/PlanCheck";
import GroupBenefitsWoodlands from "@/pages/GroupBenefitsWoodlands";
import HarvestScan from "@/pages/HarvestScan";
import { SeoManager } from "@/components/SeoManager";
import AdminRoutes from "@/admin/AdminRoutes";
import BookingPage from "@/pages/BookingPage";
import ManageBooking from "@/pages/ManageBooking";
import { DeskLink } from "@/components/DeskLink";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollTop();
  }, [pathname]);
  return null;
}

function PublicSite() {
  useEffect(() => {
    const destroy = initLenis();
    return destroy;
  }, []);

  return (
    <div className="bg-cream font-sans text-ink antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/individuals" element={<Individuals />} />
          <Route path="/employers" element={<Employers />} />
          <Route path="/group-benefits-the-woodlands" element={<GroupBenefitsWoodlands />} />
          <Route path="/about" element={<About />} />
          <Route path="/education" element={<Education />} />
          <Route path="/education/:slug" element={<ArticlePage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/benefits-decoded" element={<BenefitsDecoded />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/plan-check" element={<PlanCheck />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <DeskLink />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SeoManager />
        <Routes>
          <Route path="/admin/*" element={<AdminRoutes />} />
          {/* Public booking pages: their own chrome, no site nav or footer. */}
          <Route path="/book/:slug" element={<BookingPage />} />
          {/* A prospect's own link, from the confirmation email, to move or cancel. */}
          <Route path="/booking/:bookingId" element={<ManageBooking />} />
          {/* Short, bookmarkable way into the Growth Desk. Not linked anywhere public. */}
          <Route path="/desk" element={<Navigate to="/admin" replace />} />
          {/* QR codes printed on Harvest Plan cards: logs the scan, then forwards. */}
          <Route path="/h/:slug" element={<HarvestScan />} />
          <Route path="/*" element={<PublicSite />} />
        </Routes>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: "#1A3626", color: "#F9F7F1", border: "1px solid rgba(212,175,55,0.4)" },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
